import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Block from "@material-ui/icons/Block";
import classnames from "classnames";
import history from "../common/history";

import { Title } from "react-admin";

import TranslatedText from "./TranslatedText";

const styles = theme => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        [theme.breakpoints.up("md")]: {
            height: "100%"
        },
        [theme.breakpoints.down("sm")]: {
            height: "100vh",
            marginTop: "-3em"
        }
    },
    icon: {
        width: "9em",
        height: "9em"
    },
    message: {
        textAlign: "center",
        fontFamily: "Roboto, sans-serif",
        opacity: 0.5,
        margin: "0 1em"
    },
    toolbar: {
        textAlign: "center",
        marginTop: "2em"
    }
});

function goBack() {
    history.go(-1);
}

const PermissionDenied = ({ classes, className }) => (
    <div className={classnames(classes.container, className)}>
        <Title defaultTitle="TeamSystem Cloud Console" />
        <div className={classes.message}>
            <Block className={classes.icon} />
            <h1>{<TranslatedText resource_name="Unauthorized" />}</h1>
            <div>{<TranslatedText resource_name="no_permission" />}</div>
        </div>
        <div className={classes.toolbar}>
            <Button variant="raised" onClick={goBack}>
                {<TranslatedText resource_name="ra.action.back" />}
            </Button>
        </div>
    </div>
);

PermissionDenied.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string
};

export default withStyles(styles)(PermissionDenied);



// WEBPACK FOOTER //
// ./src/components/PermissionDenied.js